// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import { format } from "date-fns"
import { Map, Record } from "immutable"

import Summaries from "./Summaries"
import { MONTH_FNS_FORMAT } from "../consts/date"

const MonthPricesRecord = Record({
  days: Map(),
  loading: false,
  loaded: false,
  summaries: new Summaries(),
})

class MonthPrices extends MonthPricesRecord {
  constructor(raw = {}) {
    const input = { ...raw }
    if (input.days) {
      input.summaries = input.days.reduce((acc, price) => {
        let next = acc

        if (!next.get("max") || next.get("max") < price) {
          next = next.set("max", price)
        }

        if (!next.get("min") || next.get("min") > price) {
          next = next.set("min", price)
        }

        return next.set("results", next.get("results") + 1)
      }, new Summaries())
    }

    super(input)
  }

  static getId(month, year) {
    return format(new Date(year, month, 1), MONTH_FNS_FORMAT)
  }
}

export default MonthPrices
